import { Component, OnInit } from '@angular/core';
import { CommonService } from '../../service/common.service';
import { Router } from '@angular/router';
import { Catalogo } from '../../models/catalogo';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { configurazione } from '../../../configurazioni/configurazione';
import { ChangeDetectionStrategy} from '@angular/core';
import { NativeDateAdapter} from '@angular/material/core';
import { MatDatepickerModule} from '@angular/material/datepicker';
import { MatFormFieldModule} from '@angular/material/form-field';
import { MatInputModule} from '@angular/material/input';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';

@Component({
  selector: 'app-addcatalogo',
  templateUrl: './addcatalogo.component.html',
  styleUrls: ['./addcatalogo.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AddcatalogoComponent implements OnInit {
//  readonly startDate = new Date(2025, 1, 1);
//  readonly endDate = new Date(2025, 1, 1);
  minEndDate: Date;
  catalogo: Catalogo;

  rc:number;
  registerForm: FormGroup;

  public message =  sessionStorage.getItem('token');

  constructor(private commonService: CommonService,
    private router: Router, private formBuilder: FormBuilder) {

    }

  ngOnInit(): void {

    this.catalogo=new Catalogo();
    this.minEndDate=new Date();

    if (this.registerForm===undefined){
    this.registerForm = this.formBuilder.group({
        Codice:[0],
        Nome: ['',Validators.required],
        Descrizione: [''],
        Datavalidodal: ['',Validators.required],
        Datavalidoal: ['',Validators.required],
        Categoria: [''],
        Codicefornitore: [0],
        });
    }

          if (this.commonService.selectedCatalogo!=undefined){
            this.catalogo=this.commonService.selectedCatalogo;
            this.commonService.selectedCatalogo=undefined;

            if (this.catalogo.Datavalidodal===undefined){
              this.catalogo.Datavalidodal=new Date();
            }
            if (this.catalogo.Datavalidoal===undefined){
              this.catalogo.Datavalidoal=new Date();
            }

            this.registerForm.setValue({
                Codice:this.catalogo.Codice,
                Nome:this.catalogo.Nome,
                Descrizione:this.catalogo.Descrizione,
                Datavalidodal:this.catalogo.Datavalidodal,
                Datavalidoal:this.catalogo.Datavalidoal,
                Categoria:this.catalogo.Categoria,
                Codicefornitore:this.catalogo.Categoria,
              });


          }else{
            this.catalogo=new Catalogo();
          }
  }

aggiornaForm(){

  this.registerForm.setValue({
      Codice:this.catalogo.Codice,
      Nome:this.catalogo.Nome,
      Descrizione:this.catalogo.Descrizione,
      Datavalidodal:this.catalogo.Datavalidodal,
      Datavalidoal:this.catalogo.Datavalidoal,
      Categoria:this.catalogo.Categoria,
      Codicefornitore:this.catalogo.Categoria,
    });

}

get f() { return this.registerForm.controls; }

save() {

        if (this.registerForm.invalid) {
            alert("Errore: verifica i campi indicati con *");
            return;
        }else{
            console.log("Save catalogo");

            let s=this.dateToString(this.registerForm.value.Datavalidodal);
            if (s!=''){
              this.registerForm.value.Datavalidodal=s;
            }
            let e=this.dateToString(this.registerForm.value.Datavalidoal);
            if (e!=''){
              this.registerForm.value.Datavalidoal=e;
            }

            this.commonService.saveCatalogo(this.registerForm.value).subscribe(data => {
              this.rc=Number(data); //ritorna l'id dell'utente se è stato creato con successo
              //console.log("--->SaveUser"+this.rc.toString());
              if (this.rc===0){
                alert("Catalogo già esistente");
              }else if (this.rc===-1){
                alert("Errore creazione catalogo");
              }else {
                alert("Catalogo salvata con successo");
                this.router.navigate(['cataloghi']);
              }
            });
        }
    }

  cancel(){
    this.commonService.selectedCommessa=null;
    this.router.navigate(['cataloghi']);
  }

  dateToString(d: Date): string {
    let s:string='9999-12-31';
    if(d!=undefined){
      if (d instanceof Date){
//        console.log("--->"+d);
      }else{
        return '';
      }
      let month:string = (d.getMonth()+1).toString();
      if ((d.getMonth()+1)<10){
        month='0'+month;
      }

      let year = d.getFullYear().toString();
      let day = d.getDate().toString();
      if (d.getDate().toString().length == 1){
        day='0'+day;
      }
      s=year+'-'+month+'-'+day;
    }
    return s;
  }

onStartDateChange(event: MatDatepickerInputEvent<Date>) {

  if (event.value!=null){
    this.minEndDate=new Date(event.value);
  }
 }

  startDateFilter(d: Date): boolean {
    return true;
  //		const selectinableday = d.getDay();

    if(d!=undefined){
      if (d.getTime()>this.minEndDate.getTime()){
        return true;
      }else{
        return false;
      }
    }
    return false;
  }

  endDateFilter(d: Date): boolean {

      return true;
  if(d!=undefined){
    console.log(d.getTime());
    console.log(this.minEndDate.getTime());
    if (d.getTime()>this.minEndDate.getTime()){
      return true;
    }else{
      return false;
    }
  }
   return false;
  }
  getConfigurazione(){
    return configurazione.addcatalogo;
  }
}
